import { useMemo } from 'react';
import { add, remove } from 'actions/toast';
import useAction from './useAction';

export function promiseWithToast(
  promise,
  { successCallback, successMsg, errorCallback, errorMsg, addToast },
) {
  return promise
    .then(() => {
      if (successCallback) {
        successCallback();
      }
      if (successMsg) {
        addToast({
          type: 'success',
          message: successMsg,
        });
      }
    })
    .catch(() => {
      if (errorCallback) {
        errorCallback();
      }
      addToast({
        type: 'error',
        message: errorMsg,
      });
    });
}

/**
 * gives access to add/remove toast functionality directly from a hook
 * @returns {{removeToast: function, addToast: function}}
 */
export default function useToast() {
  const addToast = useAction(add);
  const removeToast = useAction(remove);
  const promiseWithToastWrapper = useMemo(
    () => (promise, opts) => promiseWithToast(promise, { addToast, ...opts }),
    [addToast],
  );

  return {
    addToast,
    removeToast,
    promiseWithToast: promiseWithToastWrapper,
  };
}
